export default "__VITE_ASSET__706b8a4e__"